import { useEffect, useState, useCallback } from "react";
import { fetchFoundingStats } from "@/lib/api";

const DEFAULT = {
  founders_claimed: 0,
  founders_total: 45,
  founders_remaining: 45,
  founders_closed: false,
  passes_claimed: 0,
  passes_total: 55,
  passes_remaining: 55,
  passes_closed: false,
  total_claimed: 0,
  total_cap: 100,
  all_closed: false,
  loaded: false,
};

export function useFoundingStats() {
  const [stats, setStats] = useState(DEFAULT);

  const refresh = useCallback(async () => {
    try {
      const data = await fetchFoundingStats();
      setStats({ ...data, loaded: true });
    } catch {
      setStats((s) => ({ ...s, loaded: true }));
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  return { stats, refresh };
}
